import React from 'react';

const SignUp1 = React.lazy(() => import('./Demo/Authentication/SignUp/SignUp1'));
const Signin1 = React.lazy(() => import('./Demo/Authentication/SignIn/SignIn1'));
const Register = React.lazy(() => import('./routes/Auth/SignUp1'));
const Login = React.lazy(() => import('./routes/Auth/SignIn1'));
const WelcomePage = React.lazy(() => import('./routes/Auth/WelcomePage'));
const RegisterKlinik = React.lazy(() => import('./routes/Auth/RegisterKlinik'));
const VerifikasiPassword = React.lazy(() => import('./routes/Auth/VerifikasiPassword'));

const route = [
    { path: '/auth/signup', exact: true, name: 'Signup', component: SignUp1 },
    { path: '/auth/signin', exact: true, name: 'Signin', component: Signin1 },
    { path: '/auth/register', exact: true, name: 'Register', component: Register },
    { path: '/auth/login', exact: true, name: 'Login', component: Login },
    { path: '/auth/welcome-hicare', exact: true, name: 'Welcome', component: WelcomePage },
    { path: '/auth/register-klinik', exact: true, name: 'Login', component: RegisterKlinik },
    { path: '/auth/verifikasi-password/:generatedUri/:id', exact: true, name: 'Login', component: VerifikasiPassword },
];

export default route;